"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockGenesisTerminalPart = exports.createMockPartAndVersionData = void 0;
exports.createMockPartVersion = createMockPartVersion;
exports.createMockResistor = createMockResistor;
exports.createMockFootprintPartVersion = createMockFootprintPartVersion;
exports.createMockSchematicTerminal = createMockSchematicTerminal;
exports.createMockSchematicTerminalMap = createMockSchematicTerminalMap;
exports.createMockParts = createMockParts;
exports.createMockSubLayoutPartVersion = createMockSubLayoutPartVersion;
/* eslint-disable @typescript-eslint/no-magic-numbers */
const lodash_1 = require("lodash");
const constants_1 = require("../../src/part/constants");
const pcb_1 = require("../../src/pcb");
const helpers_1 = require("../helpers");
const mockElementData_1 = require("./mockElementData");
const mockPcbNodeData_1 = require("./mockPcbNodeData");
const mockPcbRuleData_1 = require("./mockPcbRuleData");
const mockPrimitiveData_1 = require("./mockPrimitiveData");
/**
 * By default, creates a part with two pads.
 */
function createMockPartVersion(overrides, mergeOverrides = false, chanceSeed = undefined) {
    if (chanceSeed) {
        (0, helpers_1.initChanceSeed)(chanceSeed);
    }
    const partVersion = {
        created_at: helpers_1.chance.timestamp(),
        name: helpers_1.chance.name(),
        owner_uid: helpers_1.chance.guid(),
        // In general, tests could have multiple parts created, so this needs to be unique
        part_uid: helpers_1.chance.guid(),
        version: constants_1.headVersionName,
        terminals: {
            "terminal-1": {
                uid: "terminal-1",
            },
            "terminal-2": {
                uid: "terminal-2",
            },
        },
        extracted_element_cache: {
            "terminal-1": {
                properties: {
                    designator_prefix: "P",
                    part_type: "Terminal",
                    pin_number: "1",
                    pin_type: "Unspecified",
                    symbol_pin_position: {
                        data: {
                            x: 16,
                            y: 0,
                        },
                        type: "vector2",
                    },
                    terminal_order: "",
                },
            },
            "terminal-2": {
                properties: {
                    designator_prefix: "P",
                    part_type: "Terminal",
                    pin_number: "2",
                    pin_type: "Unspecified",
                    symbol_pin_position: {
                        data: {
                            x: 16,
                            y: 0,
                        },
                        type: "vector2",
                    },
                    terminal_order: "",
                },
            },
        },
        document_import_uid: "part-doc-1",
        pcbLayoutNodes: {
            "footprint-one": (0, mockPcbNodeData_1.mockPcbLayoutFootprintNode)({
                uid: "footprint-one",
                name: "footprint-one",
                parentUid: pcb_1.pcbLayoutRootNodeId,
                pcbNodeRuleSet: {},
            }),
            "terminal-1": (0, mockPcbNodeData_1.mockPcbLayoutPadNode)({
                uid: "terminal-1",
                name: "pad-one",
                parentUid: "footprint-one",
                terminalId: "",
                pcbNodeRuleSet: {
                    position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
                    rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
                },
            }),
            "terminal-2": (0, mockPcbNodeData_1.mockPcbLayoutPadNode)({
                uid: "terminal-2",
                name: "pad-two",
                parentUid: "footprint-one",
                terminalId: "",
                pcbNodeRuleSet: {
                    position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
                    rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
                },
            }),
        },
        pcbLayoutRuleSets: {},
        properties: {},
    };
    if (mergeOverrides) {
        (0, lodash_1.merge)(partVersion, overrides);
    }
    else {
        Object.assign(partVersion, overrides);
    }
    return partVersion;
}
function createMockResistor(params) {
    const twoPadPart = createMockPartVersion();
    return (0, mockElementData_1.mockElementData)({
        uid: params.uid,
        label: params.designator,
        part_uid: twoPadPart.part_uid,
        part_version: twoPadPart.version,
        // NOTE: copied from dev console
        part_version_data_cache: twoPadPart,
        // NOTE: copied from dev console
        properties: {
            "0406b76f-b792-5b71-5c13-27e985ab4729": {
                uid: "0406b76f-b792-5b71-5c13-27e985ab4729",
                name: "Part Type",
                value: "Resistor",
            },
            "091cd9cc-a638-22eb-fe71-8f54318c114d": {
                uid: "091cd9cc-a638-22eb-fe71-8f54318c114d",
                name: "Manufacturer Name",
                value: "YAGEO",
            },
            "0fb2d23a-fd8a-4f5e-8d23-090fa4487dcf": {
                uid: "0fb2d23a-fd8a-4f5e-8d23-090fa4487dcf",
                name: "Purchase Url",
                value: "https://www.mouser.com/datasheet/2/447/Yageo_08272021_CFR_Series-2530393.pdf",
            },
            "6f63c478-bfcb-89eb-4f15-84d076e7cf0b": {
                uid: "6f63c478-bfcb-89eb-4f15-84d076e7cf0b",
                name: "Manufacturer Part Number",
                value: "CFR-25JT-52-220R",
            },
            "9238774a-4da9-9ef8-6c97-14ba7962c9b8": {
                uid: "9238774a-4da9-9ef8-6c97-14ba7962c9b8",
                name: "Designator Prefix",
                value: "R",
            },
            "de3f4899-a173-50a9-9ec9-6e7711429d8f": {
                uid: "de3f4899-a173-50a9-9ec9-6e7711429d8f",
                name: "Resistance",
                value: "1k",
            },
            "f5fb6d51-0168-733a-b622-482d9bb57e7a": {
                uid: "f5fb6d51-0168-733a-b622-482d9bb57e7a",
                name: "Datasheet URL",
                value: "https://www.mouser.com/datasheet/2/447/Yageo_08272021_CFR_Series-2530393.pdf",
            },
        },
    });
}
const createMockPartAndVersionData = (overrides) => {
    const uid = helpers_1.chance.guid();
    const partUid = helpers_1.chance.guid();
    const partName = helpers_1.chance.name();
    const ownerUid = helpers_1.chance.guid();
    const HEAD = {
        part_uid: partUid,
        version: constants_1.headVersionName,
        properties: {},
        name: partName,
        terminals: {},
        created_at: 1642526962882,
        owner_uid: ownerUid,
        pcbLayoutNodes: {},
    };
    const v1 = {
        part_uid: partUid,
        version: "v1",
        properties: {
            a_new_property: { name: "a_new_property", value: true, uid: helpers_1.chance.guid() },
        },
        name: partName,
        terminals: {},
        created_at: 1642526962882,
        owner_uid: ownerUid,
    };
    return {
        part: {
            uid: uid,
            owner_uid: HEAD.owner_uid,
            created_at: HEAD.created_at,
            updated_at: HEAD.created_at,
            label: helpers_1.chance.string(),
            part_uid: partUid,
            part_version: constants_1.headVersionName,
            part_version_data_cache: HEAD,
            diagram_position: (0, mockPrimitiveData_1.mockVector2)(),
            properties: {},
        },
        versions: {
            HEAD: HEAD,
            v1: v1,
        },
        ...overrides,
    };
};
exports.createMockPartAndVersionData = createMockPartAndVersionData;
function createMockFootprintPartVersion(terminalAmount = 2, overrides) {
    const schematicTerminals = createMockSchematicTerminalMap(terminalAmount);
    const pcbPadNodes = (0, mockPcbNodeData_1.createMockPcbPadNodeMap)(schematicTerminals, { parentUid: "footprint-one" });
    return {
        created_at: helpers_1.chance.timestamp(),
        name: helpers_1.chance.name(),
        owner_uid: helpers_1.chance.guid(),
        part_uid: helpers_1.chance.guid(),
        version: constants_1.headVersionName,
        terminals: schematicTerminals,
        document_import_uid: "part-doc-1",
        pcbLayoutNodes: {
            "footprint-one": (0, mockPcbNodeData_1.createMockRootFootprintNode)({
                uid: "footprint-one",
                name: "footprint-one",
            }),
            ...pcbPadNodes,
        },
        pcbLayoutRuleSets: {},
        properties: {},
        ...overrides,
    };
}
function createMockSchematicTerminal(overrides) {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        position: (0, mockPrimitiveData_1.mockVector2)(),
        ...overrides,
    };
}
function createMockSchematicTerminalMap(terminalAmount, overrides) {
    const schematicTerminals = {};
    for (let i = 0; i < terminalAmount; i++) {
        const terminal = createMockSchematicTerminal(overrides);
        schematicTerminals[terminal.uid] = terminal;
    }
    return schematicTerminals;
}
function createMockParts(footprintsAmount, layoutsAmount) {
    const result = [];
    for (let i = 0; i < footprintsAmount; i++) {
        const part = createMockFootprintPartVersion(4, { part_uid: helpers_1.chance.guid() });
        if (part.part_uid) {
            result.push(part);
        }
    }
    for (let i = 0; i < layoutsAmount; i++) {
        const part = createMockSubLayoutPartVersion(4, 10, 6, { part_uid: helpers_1.chance.guid() });
        if (part.part_uid) {
            result.push(part);
        }
    }
    return result;
}
function createMockSubLayoutPartVersion(terminalsAmount = 10, componentsAmount = 10, terminalsPerComponentAmount = 6, overrides) {
    const layoutNodeUid = !overrides?.part_uid
        ? helpers_1.chance.guid()
        : (0, pcb_1.constructNodeUidForSubLayout)(overrides.part_uid, helpers_1.chance.guid());
    const layoutComponentsNodeUid = (0, pcb_1.constructNodeUidForSubLayout)(layoutNodeUid, helpers_1.chance.guid());
    const schematicTerminals = createMockSchematicTerminalMap(terminalsAmount);
    const pcbPadNodes = (0, mockPcbNodeData_1.createMockPcbPadNodeMap)(schematicTerminals, { parentUid: layoutNodeUid });
    let pcbElementNodes = {};
    for (let i = 0; i < componentsAmount; i++) {
        const elementUid = !overrides?.part_uid
            ? helpers_1.chance.guid()
            : (0, pcb_1.constructNodeUidForSubLayout)(overrides.part_uid, helpers_1.chance.guid());
        pcbElementNodes[elementUid] = (0, mockPcbNodeData_1.mockPcbLayoutElementNode)({
            uid: elementUid,
            parentUid: layoutComponentsNodeUid,
            pcbNodeRuleSet: {
                position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
                rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
            },
        });
        // Making sure that footprint nodes under element has `${elementUid}${nestedNodeDelimiter}` as prefix
        const footprintUid = (0, pcb_1.constructNodeUidForSubLayout)(elementUid, helpers_1.chance.guid());
        pcbElementNodes[footprintUid] = (0, mockPcbNodeData_1.mockPcbLayoutFootprintNode)({
            uid: footprintUid,
            parentUid: elementUid,
            pcbNodeRuleSet: {},
        });
        const subLayoutComponentSchematicTerminals = createMockSchematicTerminalMap(terminalsPerComponentAmount);
        const subLayoutComponentPcbPadNodes = (0, mockPcbNodeData_1.createMockPcbPadNodeMap)(subLayoutComponentSchematicTerminals, {
            parentUid: footprintUid,
        });
        // Making sure that pad nodes under element has `${elementUid}${nestedNodeDelimiter}` as prefix
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.keys(subLayoutComponentPcbPadNodes).forEach((key) => {
            const newPadNode = {
                ...subLayoutComponentPcbPadNodes[key],
                uid: `${(0, pcb_1.constructNodeUidForSubLayout)(elementUid, subLayoutComponentPcbPadNodes[key].uid)}`,
            };
            subLayoutComponentPcbPadNodes[newPadNode.uid] = newPadNode;
            delete subLayoutComponentPcbPadNodes[key];
        });
        pcbElementNodes = {
            ...pcbElementNodes,
            ...subLayoutComponentPcbPadNodes,
        };
    }
    return {
        created_at: helpers_1.chance.timestamp(),
        name: helpers_1.chance.name(),
        owner_uid: helpers_1.chance.guid(),
        part_uid: helpers_1.chance.guid(),
        version: constants_1.headVersionName,
        terminals: schematicTerminals,
        document_import_uid: "part-doc-1",
        pcbLayoutNodes: {
            [layoutNodeUid]: (0, mockPcbNodeData_1.createMockRootLayoutNode)({
                uid: layoutNodeUid,
                name: "layout",
            }),
            [layoutComponentsNodeUid]: (0, mockPcbNodeData_1.createMockComponentsNode)({
                uid: layoutComponentsNodeUid,
                name: "components-one",
                parentUid: layoutNodeUid,
            }),
            ...pcbPadNodes,
            ...pcbElementNodes,
        },
        pcbLayoutRuleSets: {},
        properties: {},
        ...overrides,
    };
}
const mockGenesisTerminalPart = (overrides) => ({
    created_at: 1582945414953,
    part_uid: "835bf3e1-33dd-41bb-a166-c0a31607d645",
    terminals: {
        "111bf4e4-02dd-41bb-a137-c0a32607d321": {
            position: {
                y: 0,
                x: -15.5,
            },
            uid: "111bf4e4-02dd-41bb-a137-c0a32607d321",
        },
    },
    owner_uid: "AuZZV45bT6ZcQCayxjDcBMvEe2s1",
    version: constants_1.headVersionName,
    pcbLayoutNodes: {
        "pad-one": (0, mockPcbNodeData_1.mockPcbLayoutPadNode)({
            uid: helpers_1.chance.guid(),
            name: pcb_1.PcbNodeTypes.pad,
            terminalId: "1",
            parentUid: "",
            pcbNodeRuleSet: {},
        }),
    },
    pcbLayoutRuleSets: {},
    properties: {
        symbol_pin_position: {
            name: "Symbol Pin Position",
            value: {
                data: {
                    y: 0,
                    x: 0,
                },
                type: "vector2",
            },
            uid: "symbol_pin_position",
            order: 4,
        },
        designator_prefix: {
            value: "P",
            uid: "designator_prefix",
            order: 3,
            name: "Designator Prefix",
        },
        part_type: {
            name: "Part Type",
            order: 1,
            uid: "part_type",
            value: "Terminal",
        },
        pin_number: {
            uid: "pin_number",
            value: "",
            order: 5,
            name: "Pin Number",
        },
        terminal_order: {
            name: "Terminal Order",
            value: "",
            order: 2,
            unit: "",
            uid: "terminal_order",
        },
        pin_type: {
            order: 0,
            value: "Unspecified",
            name: "Pin Type",
            uid: "pin_type",
        },
    },
    preview_image: "e1a6bd7b-9613-c899-c62f-c13158e80424-terminal.svg",
    symbol_resource_file: "5fe23261-d088-0724-13d9-4922319aae37-terminal.glb",
    description: "An electrical connector acting as reusable interface to a conductor and creating a point where external circuits can be connected.",
    name: "Terminal",
    ...overrides,
});
exports.mockGenesisTerminalPart = mockGenesisTerminalPart;
//# sourceMappingURL=mockPartData.js.map